import { useEffect, useState } from "react";
import { Save, Wrench } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { formatEuro } from "@/lib/constants";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

export function InterventiCatalogo({ pratica, onSaved }) {
  const [catalogo, setCatalogo] = useState([]);
  const [sel, setSel] = useState(pratica.interventi || []);
  useEffect(() => { api.get("/aree").then((r) => setCatalogo(r.data.aree.ingegnere.sezioni)); }, []);
  const find = (v) => sel.find((x) => x.nome === v);
  const toggle = (sezione, v) => setSel(find(v) ? sel.filter((x) => x.nome !== v) : [...sel, { nome: v, sezione, importo: 0, note: "" }]);
  const setImporto = (v, importo) => setSel(sel.map((x) => (x.nome === v ? { ...x, importo: Number(importo) } : x)));
  const totale = sel.reduce((n, x) => n + (Number(x.importo) || 0), 0);
  const save = async () => {
    try { const { data } = await api.patch(`/pratiche/${pratica.id}`, { interventi: sel }); onSaved(data); toast.success("Interventi salvati"); } catch (err) { toast.error(formatApiError(err)); }
  };
  return (
    <div className="space-y-5" data-testid="interventi-catalogo">
      <div className="bg-white border border-slate-200 rounded-xl p-6 flex flex-wrap items-center justify-between gap-4">
        <div className="flex items-center gap-2"><Wrench size={18} className="text-[#003087]" /><div><h3 className="font-heading text-lg font-medium text-slate-900">Interventi di riqualificazione previsti</h3><p className="text-xs text-slate-500">Seleziona dal catalogo e stima l'importo: alimenta relazione tecnica, PEF e criteri A, C, D.</p></div></div>
        <div className="text-right"><div className="text-[11px] uppercase tracking-wider text-slate-500">{sel.length} interventi · totale stimato</div><div className="font-heading text-2xl font-semibold text-[#003087]" data-testid="interventi-totale">{formatEuro(totale)}</div></div>
      </div>
      {catalogo.map((s) => (
        <div key={s.titolo} className="bg-white border border-slate-200 rounded-xl p-5">
          <h4 className="font-heading font-medium text-slate-900 mb-2">{s.titolo}</h4>
          <div className="divide-y divide-slate-100">
            {s.voci.map((v) => { const it = find(v); return (
              <div key={v} className="flex flex-wrap items-center gap-3 py-2">
                <input type="checkbox" checked={!!it} onChange={() => toggle(s.titolo, v)} className="h-4 w-4 accent-[#003087]" data-testid={`intervento-check-${v.slice(0, 20).replace(/\W+/g, "-")}`} />
                <span className={`flex-1 text-sm ${it ? "text-slate-900 font-medium" : "text-slate-600"}`}>{v}</span>
                {it && <Input type="number" min={0} value={it.importo} onChange={(e) => setImporto(v, e.target.value)} placeholder="Importo €" className="h-8 w-36 bg-slate-50 text-xs" />}
              </div>); })}
          </div>
        </div>
      ))}
      <div className="flex justify-end"><Button onClick={save} className="bg-[#003087] hover:bg-[#0070BA]" data-testid="interventi-save-button"><Save size={15} className="mr-2" /> Salva interventi</Button></div>
    </div>
  );
}
